export interface Candidate {
  id: string;
  name: string;
  email: string;
  phone: string;
  avatar: string;
  title: string;
  skills: string[];
  experience: number;
  location: string;
  education: string;
  institute: string;
  graduationYear: number;
  dateOfBirth: string;
  age: number;
  gender: string;
  country: string;
  rating: number;
  status: 'new' | 'reviewed' | 'shortlisted' | 'interviewed' | 'hired' | 'rejected';
  appliedDate: string;
  aboutMe: string;
  certifications: string[];
  isOnline: boolean;
}

export interface Interview {
  id: string;
  candidateId: string;
  candidateName: string;
  position: string;
  date: string;
  time: string;
  type: 'video' | 'phone' | 'in-person';
  status: 'scheduled' | 'completed' | 'cancelled';
  notes?: string;
}

export interface Task {
  id: string;
  candidateId: string;
  candidateName: string;
  title: string;
  description: string;
  dueDate: string;
  status: 'pending' | 'in-progress' | 'submitted' | 'reviewed';
  createdAt: string;
}

export const candidates: Candidate[] = [
  {
    id: '1',
    name: 'Agesh K S',
    email: 'agesh.ks@email.com',
    phone: '+91 9876543210',
    avatar: '',
    title: 'Frontend Developer, Cybersecurity Analyst, Flutter Developer',
    skills: ['Flutter', 'Dart', 'React', 'TypeScript', 'Cybersecurity'],
    experience: 4,
    location: 'Bangalore, India',
    education: 'BSc Physics',
    institute: 'St Aloysius College Elthuruth',
    graduationYear: 2019,
    dateOfBirth: '1997-04-11',
    age: 28,
    gender: 'Male',
    country: 'India',
    rating: 4.5,
    status: 'new',
    appliedDate: '2024-01-15',
    aboutMe: 'Passionate Flutter Developer | Building Beautiful Cross-Platform Mobile Experiences. I specialize in crafting high-performance, visually stunning mobile applications using Flutter and Dart. With a focus on clean architecture and intuitive user interfaces, I transform ideas into seamless cross-platform experiences that users love.',
    certifications: ['AWS Certified Developer', 'Google Flutter Certification'],
    isOnline: true,
  },
  {
    id: '2',
    name: 'Priya Sharma',
    email: 'priya.sharma@email.com',
    phone: '+91 9876543211',
    avatar: '',
    title: 'Full Stack Developer',
    skills: ['React', 'Node.js', 'Python', 'MongoDB', 'AWS'],
    experience: 5,
    location: 'Mumbai, India',
    education: 'B.Tech Computer Science',
    institute: 'IIT Mumbai',
    graduationYear: 2018,
    dateOfBirth: '1996-08-22',
    age: 28,
    gender: 'Female',
    country: 'India',
    rating: 4.8,
    status: 'shortlisted',
    appliedDate: '2024-01-10',
    aboutMe: 'Experienced full-stack developer with a passion for building scalable web applications. Strong background in cloud technologies and microservices architecture.',
    certifications: ['AWS Solutions Architect', 'MongoDB Certified Developer'],
    isOnline: false,
  },
  {
    id: '3',
    name: 'Rahul Verma',
    email: 'rahul.verma@email.com',
    phone: '+91 9876543212',
    avatar: '',
    title: 'Senior Backend Developer',
    skills: ['Java', 'Spring Boot', 'Kubernetes', 'PostgreSQL', 'Redis'],
    experience: 7,
    location: 'Delhi, India',
    education: 'M.Tech Software Engineering',
    institute: 'IIIT Delhi',
    graduationYear: 2016,
    dateOfBirth: '1993-03-15',
    age: 31,
    gender: 'Male',
    country: 'India',
    rating: 4.7,
    status: 'interviewed',
    appliedDate: '2024-01-05',
    aboutMe: 'Senior backend developer with expertise in distributed systems and high-performance applications. Led teams of 10+ developers on enterprise projects.',
    certifications: ['Oracle Certified Professional', 'Kubernetes Administrator'],
    isOnline: true,
  },
  {
    id: '4',
    name: 'Ananya Patel',
    email: 'ananya.patel@email.com',
    phone: '+91 9876543213',
    avatar: '',
    title: 'UI/UX Designer & Frontend Developer',
    skills: ['Figma', 'React', 'Tailwind CSS', 'Adobe XD', 'JavaScript'],
    experience: 3,
    location: 'Pune, India',
    education: 'B.Des Interaction Design',
    institute: 'NID Ahmedabad',
    graduationYear: 2020,
    dateOfBirth: '1998-11-08',
    age: 26,
    gender: 'Female',
    country: 'India',
    rating: 4.6,
    status: 'reviewed',
    appliedDate: '2024-01-18',
    aboutMe: 'Creative UI/UX designer with strong frontend development skills. I believe in creating designs that are not only beautiful but also highly functional and accessible.',
    certifications: ['Google UX Design Certificate', 'Meta Frontend Developer'],
    isOnline: true,
  },
  {
    id: '5',
    name: 'Vikram Singh',
    email: 'vikram.singh@email.com',
    phone: '+91 9876543214',
    avatar: '',
    title: 'DevOps Engineer',
    skills: ['Docker', 'Kubernetes', 'AWS', 'Terraform', 'Jenkins'],
    experience: 6,
    location: 'Hyderabad, India',
    education: 'B.Tech Information Technology',
    institute: 'BITS Pilani',
    graduationYear: 2017,
    dateOfBirth: '1995-06-20',
    age: 29,
    gender: 'Male',
    country: 'India',
    rating: 4.4,
    status: 'new',
    appliedDate: '2024-01-20',
    aboutMe: 'DevOps engineer passionate about automating everything. Expert in CI/CD pipelines, infrastructure as code, and cloud-native technologies.',
    certifications: ['AWS DevOps Professional', 'HashiCorp Terraform Associate'],
    isOnline: false,
  },
];

export const interviews: Interview[] = [
  {
    id: '1',
    candidateId: '2',
    candidateName: 'Priya Sharma',
    position: 'Full Stack Developer',
    date: '2024-01-25',
    time: '10:00 AM',
    type: 'video',
    status: 'scheduled',
  },
  {
    id: '2',
    candidateId: '3',
    candidateName: 'Rahul Verma',
    position: 'Senior Backend Developer',
    date: '2024-01-26',
    time: '2:00 PM',
    type: 'in-person',
    status: 'scheduled',
  },
];

export const tasks: Task[] = [
  {
    id: '1',
    candidateId: '2',
    candidateName: 'Priya Sharma',
    title: 'Build a REST API',
    description: 'Create a RESTful API for a todo application with CRUD operations',
    dueDate: '2024-01-28',
    status: 'pending',
    createdAt: '2024-01-20',
  },
  {
    id: '2',
    candidateId: '4',
    candidateName: 'Ananya Patel',
    title: 'Design a Dashboard',
    description: 'Create a modern dashboard design in Figma for an analytics platform',
    dueDate: '2024-01-30',
    status: 'in-progress',
    createdAt: '2024-01-18',
  },
];

export const dashboardStats = {
  totalCandidates: 156,
  shortlisted: 24,
  interviewsScheduled: 12,
  hired: 8,
  pendingTasks: 15,
  applicationsThisWeek: 32,
};
